import React from "react";

/**
 * Shimmering skeleton that mirrors HostelCard's exact dimensions.
 * Reserves the same aspect-[4/3] image slot + text rows so the layout
 * never jumps once real cards mount.
 */
export default function HostelCardSkeleton() {
  return (
    <div
      data-testid="hostel-card-skeleton"
      className="bg-white border border-sandstone-200 rounded-2xl overflow-hidden shadow-sm"
      aria-hidden="true"
    >
      <div className="relative aspect-[4/3] bg-gradient-to-br from-sandstone-100 via-slate-100 to-sandstone-100 shimmer" />
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 space-y-2">
            <div className="h-5 rounded bg-sandstone-100 shimmer w-3/4" />
            <div className="h-3 rounded bg-sandstone-100 shimmer w-1/2" />
          </div>
          <div className="space-y-2 shrink-0">
            <div className="h-6 rounded bg-sandstone-100 shimmer w-16 ml-auto" />
            <div className="h-3 rounded bg-sandstone-100 shimmer w-14 ml-auto" />
          </div>
        </div>
        <div className="flex gap-1.5 pt-1">
          <div className="h-5 rounded bg-sandstone-100 shimmer w-24" />
          <div className="h-5 rounded bg-sandstone-100 shimmer w-16" />
          <div className="h-5 rounded bg-sandstone-100 shimmer w-12" />
        </div>
        <div className="flex items-center justify-between pt-1">
          <div className="h-3 rounded bg-sandstone-100 shimmer w-20" />
          <div className="h-3 rounded bg-sandstone-100 shimmer w-24" />
        </div>
      </div>
    </div>
  );
}
